module.exports = __webpack_public_path__ + "static/media/family-icon.01c883de.svg";